import * as React from "react";
import { connect } from "react-redux";

import { Button, Grid, Table, InputOnChangeData, Input, Divider, Container } from "semantic-ui-react";

import { Authorize } from "reauthorize";

import Utils from "@teamprevent/common/utils";

import { CustomerUserListModel, CustomerUser } from "../model";
import { customerUsersSelector, SelectorState } from "../selectors";
import { CUSTOMER_ROLES } from "../../../auth/model";

import { Link, push } from "redux-little-router";

interface AllProps {
    customerUsers: CustomerUserListModel[];
    path: string;
}

interface AllDispatchProps {
    onFilterValueChange: (firstName: string) => void;
}

interface AllState {
    firstName: string;
}

export class All extends React.Component<AllProps & AllDispatchProps, AllState> {
    constructor(props: AllProps & AllDispatchProps) {
        super(props);
        this.state = {
            firstName: ""
        };
        this.onFilterValueChange = this.onFilterValueChange.bind(this);
    }
    public render() {
        return (
            <Container>
                <Grid container className="nomargintop">
                    <Grid.Row verticalAlign="middle" columns="equal">
                        <Grid.Column>
                            <h1>Users</h1>
                        </Grid.Column>
                        <Grid.Column textAlign="right">
                            <Authorize authorize={CUSTOMER_ROLES.customerAdministrator.name}>
                                <Button secondary content="Create new" as={Link} href={`${this.props.path}/create`} />
                            </Authorize>
                        </Grid.Column>
                    </Grid.Row>
                    <Divider />
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Table>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Email Address</Table.HeaderCell>
                                        <Table.HeaderCell>First Name</Table.HeaderCell>
                                        <Table.HeaderCell>Surname</Table.HeaderCell>
                                        <Table.HeaderCell>Active</Table.HeaderCell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell />

                                        <Table.Cell>
                                            <Input
                                                value={this.state.firstName}
                                                onChange={this.onFilterValueChange}
                                                icon="search"
                                                placeholder="Filter..."
                                                size="mini"
                                            />
                                        </Table.Cell>

                                        <Table.Cell />

                                        <Table.Cell />

                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {this.props.customerUsers.map(customerUser => (
                                        <Table.Row key={customerUser.id}>
                                            <Table.Cell>
                                                <Link href={`${this.props.path}/${customerUser.id}`}>
                                                    {customerUser.emailAddress}
                                                </Link>
                                            </Table.Cell>

                                            <Table.Cell>
                                                <Link href={`${this.props.path}/${customerUser.id}`}>
                                                    {customerUser.firstName}
                                                </Link>
                                            </Table.Cell>

                                            <Table.Cell>
                                                <Link href={`${this.props.path}/${customerUser.id}`}>
                                                    {customerUser.surname}
                                                </Link>
                                            </Table.Cell>

                                            <Table.Cell>
                                                {Utils.BoolToString(customerUser.active)}
                                            </Table.Cell>

                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
    private onFilterValueChange(event: any, { value }: InputOnChangeData) {
        this.setState({ firstName: value });
        this.props.onFilterValueChange(value);
    }
}

function mapStateToProps(state: SelectorState): AllProps {
    const sortableName = (u: CustomerUser) => `${u.surname}, ${u.firstName}`;
    return {
        path: state.router.pathname,
        customerUsers: customerUsersSelector(state).sort((a, b) => sortableName(a).localeCompare(sortableName(b)))
    };
}

function mapDispatchToProps(dispatch: any): AllDispatchProps {
    return {
        onFilterValueChange: Name => dispatch(push("?firstName=" + `${Name}`))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(All);
